import React, { Component } from 'react';
import {
  View,
  TouchableWithoutFeedback,
  Dimensions,
  Animated,
  PanResponder,
  Platform,
  BackHandler,
} from 'react-native';

import { ImagePropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon, AnimationView, BlinkView } from '@vfgroup-oneplatform/foundation/Components';
import {
  Metrics,
  getThemeImages,
  withTheme,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { getDirection } from '../../Utils';
import { DIRECTIONS, MIN_HEADER_SIZE } from '../../Utils/Enums';

import styles from './EverythingIsOkHeaderStyles';

const { height: screenHight, width: screenWidht } = Dimensions.get('window');
const isAndroidDevice = Platform.OS === 'android';
const ICON_SIZE = 40;
const BLINK_RATE = 500;

class EverythingIsOkHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRun: false,
      isOpend: false,
      heighAnimation: new Animated.Value(MIN_HEADER_SIZE),
      showDetailsIcons: true,
    };
  }

  componentDidMount() {
    const { onRefresh, refreshInterval } = this.props;
    if (_isFunction(onRefresh) && refreshInterval) {
      this.onRefreshInterval = setInterval(onRefresh, refreshInterval);
    }
  }

  componentDidUpdate() {
    if (this.state.isOpend) {
      this.BackHandlerEventListener = BackHandler.addEventListener(
        'hardwareBackPress',
        this.handleBackPress,
      );
    } else if (!this.state.isOpend) {
      _isFunction(_get(this.BackHandlerEventListener, 'removeEventListener')) &&
        this.BackHandlerEventListener.removeEventListener();
    }
  }

  componentWillUnmount() {
    clearInterval(this.onRefreshInterval);
  }

  handleBackPress = () => {
    const { isOpend } = this.state;
    if (isOpend) {
      this.handleExpandingAnimation();
      return true;
    }
  };

  isMovement = drag =>
    (this.state.isOpend && drag === DIRECTIONS.up) ||
    (!this.state.isOpend && drag === DIRECTIONS.down);
  isPressingOnLogo = gestureState => {
    const { x, y } = this.logoPosition;
    const { moveX, moveY } = gestureState;
    const { logoSize } = this.props;
    const isXWithinLogo = moveX > x && moveX < x + logoSize + 20;
    const isYWithinLogo = moveY > y && moveY < y + logoSize + 20;
    return isXWithinLogo && isYWithinLogo;
  };
  panResponder = PanResponder.create({
    disableScrollViewPanResponder: true,
    onMoveShouldSetPanResponder: (evt, gestureState) => {
      const drag = getDirection(gestureState);
      const _isMovement =
        this.isMovement(drag) && this.props.expandable && !this.isPressingOnLogo(gestureState);
      if (_isMovement && !isAndroidDevice) {
        this.props.onExpantionChange(false);
      }
      return _isMovement;
    },
    onPanResponderMove: (evt, gestureState) => {
      const drag = getDirection(gestureState);

      if (this.isMovement(drag) && gestureState.moveY > MIN_HEADER_SIZE) {
        if (this.state.showDetailsIcons) {
          this.setState({ showDetailsIcons: false });
        }
        this.state.heighAnimation.setValue(gestureState.moveY);
      }
    },
    onPanResponderRelease: (evt, gestureState) => {
      this.handleExpandingAnimation();
    },
  });

  handleExpandingAnimation = forceDuration => {
    const { isOpend, heighAnimation } = this.state;
    const { expandable } = this.props;
    if (!expandable) {
      return;
    }
    const toValue = isOpend ? MIN_HEADER_SIZE : screenHight;
    if (this.state.showDetailsIcons) {
      this.setState({ showDetailsIcons: false });
    }
    this.props.onExpantionChange(false);
    this.props.getAnimationValue(this.state.heighAnimation);
    const fullDuration = isAndroidDevice ? 800 : 400;
    const progress = isOpend
      ? heighAnimation._value / screenHight
      : (screenHight - heighAnimation._value + MIN_HEADER_SIZE) / screenHight;
    const duration = progress * fullDuration;

    Animated.timing(heighAnimation, {
      toValue,
      duration: forceDuration || isAndroidDevice ? fullDuration : duration,
      useNativeDriver: false,
    }).start(() => {
      this.setState({ isOpend: !isOpend, showDetailsIcons: true }, () => {
        this.props.onExpantionChange(isOpend);
      });
    });
  };

  setUpViewRef = logoView => {
    this.logoViewRef = logoView;

    const { getLogoRef } = this.props;
    if (_isFunction(getLogoRef)) {
      getLogoRef(logoView);
    }
  };

  handleOnLogoLayout = () => {
    this.logoViewRef.measureInWindow((x, y) => {
      this.logoPosition = { x, y };
    });
  };

  handleColseExpanding = () => {
    this.handleExpandingAnimation(0);
  };

  renderIcons(icons, type) {
    const { runAnimation, blinkHeader } = this.props;
    const { isRun } = this.state;
    const _icons = [];
    if (icons.length > 0) {
      let screenWidth = Dimensions.get('window').width;
      screenWidth = screenWidth - 2 * Metrics.mainContentPadding + 10;
      let avilableNoOfIconsOnScreen = parseInt(screenWidth / 44, 10);
      if (avilableNoOfIconsOnScreen > 8) {
        avilableNoOfIconsOnScreen = 8;
      }
      let iconsNumber = icons.length;
      if (iconsNumber > avilableNoOfIconsOnScreen) {
        iconsNumber = avilableNoOfIconsOnScreen;
      }
      let i = iconsNumber - 1;
      const margin = screenWidht - ICON_SIZE * iconsNumber - 35;
      for (i; i >= 0; i--) {
        const icon = icons[i].icon;
        const status = icons[i].status;
        if (!isRun && runAnimation) {
          _icons.push(
            <AnimationView
              run
              start={150 * (iconsNumber - i)}
              from={0}
              to={0.4}
              duration={300}
              effect="opacity"
              interpolateValues={
                isRun
                  ? undefined
                  : [
                    {
                      inputRange: [0, 1],
                      outputRange: [45, -67],
                      effect: 'translateY',
                      type: 'transform',
                    },
                  ]
              }
            >
              <Icon
                key={i}
                type="image"
                name={icon}
                style={[styles.icon, styles[`icon_${type}`]]}
                size={24}
                testID={FrameworkTestKeys.EIOHeaderIcon}
              />
            </AnimationView>,
          );

          setTimeout(() => {
            this.setState({ isRun: true });
          }, 150 * iconsNumber + 200);
        } else if (isRun) {
          const translateY = this.state.heighAnimation.interpolate({
            inputRange: [MIN_HEADER_SIZE, screenHight],
            outputRange: [0, 145 + (iconsNumber - i - 1) * 63],
          });

          const translateX = this.state.heighAnimation.interpolate({
            inputRange: [MIN_HEADER_SIZE, screenHight],
            outputRange: [0, -margin - ICON_SIZE * (iconsNumber - i - 1)],
          });
          _icons.push(
            <BlinkView disabled={status !== 1 || blinkHeader} blinkRate={BLINK_RATE}>
              <AnimationView
                run
                start={0}
                from={0.4}
                to={1}
                duration={300}
                effect="opacity"
                style={{ transform: [{ translateY }, { translateX }] }}
              >
                <Icon
                  key={i}
                  type="image"
                  name={icon}
                  style={[styles.icon, styles[`icon_${type}`], styles.iconOpacity(status)]}
                  size={24}
                  testID={FrameworkTestKeys.EIOHeaderStatusIcon}
                />
              </AnimationView>
            </BlinkView>,
          );
        }
      }

      return _icons;
    }
  }

  render() {
    const {
      title,
      type,
      withSpace,
      placeHolders,
      icons,
      blinkHeader,
      theme,
      subTitle,
      status,
      logo,
      logoSize,
    } = this.props;
    const Images = getThemeImages('dark');
    const { isOpend, showDetailsIcons } = this.state;
    const spaceStyle = withSpace && !isOpend ? styles.withSpace : styles.withPartialSpace;

    const headerTitleOpacity = this.state.heighAnimation.interpolate({
      inputRange: [MIN_HEADER_SIZE, screenHight * 0.8, screenHight],
      outputRange: [1, 0, 0],
    });

    const headerCloseOpacity = this.state.heighAnimation.interpolate({
      inputRange: [MIN_HEADER_SIZE, screenHight * 0.8, screenHight],
      outputRange: [0, 0, 1],
    });

    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      // return an empty head
      return (
        <View style={{ marginTop: 32 }} >
        </View>
      )
    }

    return (
      <Animated.View
        {...this.panResponder.panHandlers}
        style={[
          styles.containerStyle,
          spaceStyle,
          styles.outerContainer,
          { height: this.state.heighAnimation },
        ]}
        testID={FrameworkTestKeys.EIOHeaderAnimatedView}
      >
        <TouchableWithoutFeedback
          testID={FrameworkTestKeys.DBHeaderLayout}
          style={styles.pulledArea}
          onPress={!isOpend ? this.handleExpandingAnimation : undefined}
          accessible={false}
        >
          <View style={[styles.pulledArea]} testID={FrameworkTestKeys.EIOHeaderPuuledAreaView}>
            <View
              style={styles.logoAndTitleContainerStyle}
              testID={FrameworkTestKeys.EIOHeaderLogoAndTitleContainerView}
            >
              <TouchableWithoutFeedback
                testID={FrameworkTestKeys.EIOHeaderLogoAndTitleContainerTWF}
              >
                <View
                  ref={this.setUpViewRef}
                  renderToHardwareTextureAndroid
                  onLayout={this.handleOnLogoLayout}
                  testID={FrameworkTestKeys.EIOHeaderLogoView}
                >
                  <Icon
                    accessibilityLabel={type}
                    testID={FrameworkTestKeys.VfLogo}
                    type="image"
                    name={logo || Images.TImages.VFLogo[type]}
                    size={logoSize}
                  />
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback
                style={styles.fullWidth}
                onPress={!isOpend ? this.handleExpandingAnimation : undefined}
                accessible={false}
                testID={FrameworkTestKeys.EIOHeaderExpandedTWF}
              >
                <View
                  style={styles.titleContainerStyle}
                  testID={FrameworkTestKeys.EIOHeaderTitleContainer}
                >
                  <BlinkView disabled={!blinkHeader} blinkRate={BLINK_RATE}>
                    <Animated.View
                      style={styles.textContainer(headerTitleOpacity)}
                      testID={FrameworkTestKeys.EIOHeaderTitleContainerAnimatedView}
                    >
                      <VFText
                        style={[styles.titleStyle]}
                        i18nKey={title}
                        placeHolders={placeHolders}
                        type={type}
                        accessibilityLabel={title}
                        testKey={FrameworkTestKeys.DBHeaderTitle}
                      />
                      {status === 0 && subTitle ? (
                        <VFText
                          style={[styles.subtitleStyle]}
                          i18nKey={subTitle}
                          placeHolders={placeHolders}
                          type={type}
                          testKey={FrameworkTestKeys.DBHeaderSubTitle}
                        />
                      ) : null}
                    </Animated.View>
                  </BlinkView>
                  <View style={styles.closeBtn} testID={FrameworkTestKeys.EIOCloseButtonView}>
                    <TouchableWithoutFeedback
                      onPress={this.handleExpandingAnimation}
                      testID={FrameworkTestKeys.EIOCloseButton}
                    >
                      <Animated.View
                        style={{ opacity: headerCloseOpacity }}
                        testID={FrameworkTestKeys.EIOHeaderCloseButtonAnimatedView}
                      >
                        <Icon
                          type="image"
                          name={Images.TImages.ic_close[type]}
                          size={24}
                          testID={FrameworkTestKeys.EIOHeaderCloseButtonIcon}
                        />
                      </Animated.View>
                    </TouchableWithoutFeedback>
                  </View>
                </View>
              </TouchableWithoutFeedback>
            </View>
            <View style={styles.iconsContainer} testID={FrameworkTestKeys.EIOHeaderIconsContainer}>
              {type === 'secondary' ? (
                <View style={styles.updateContainerStyle(!isOpend || !showDetailsIcons)}>
                  {this.renderIcons(icons, type)}
                </View>
              ) : (
                <View style={styles.space} />
              )}

              {React.Children.map(this.props.children, child =>
                React.cloneElement(child, {
                  animationValue: this.state.heighAnimation,
                  showDetailsIcons: type === 'primary' || showDetailsIcons,
                  closeExpanding: this.handleColseExpanding,
                }),
              )}
            </View>
          </View>
        </TouchableWithoutFeedback>
      </Animated.View>
    );
  }
}

EverythingIsOkHeader.defaultProps = {
  theme: LightThemeColors,
  onExpantionChange: () => { },
  getAnimationValue: () => { },
  status: 0,
  logoSize: 32,
};

EverythingIsOkHeader.propTypes = {
  onRefresh: PropTypes.func,
  type: PropTypes.string,
  refreshInterval: PropTypes.number,
  expandable: PropTypes.bool,
  onExpantionChange: PropTypes.func,
  getAnimationValue: PropTypes.func,
  renderIcons: PropTypes.func,
  runAnimation: PropTypes.bool,
  blinkHeader: PropTypes.bool,
  getLogoRef: PropTypes.func,
  title: PropTypes.string,
  withSpace: PropTypes.bool,
  theme: PropTypes.object,
  icons: PropTypes.array,
  children: PropTypes.object,
  placeHolders: PropTypes.array,
  subTitle: PropTypes.string,
  status: PropTypes.number,
  logo: ImagePropTypes.source,
  logoSize: PropTypes.number,
};

export default withTheme(EverythingIsOkHeader);
